import React, { useState, useEffect } from 'react';  
import { Table, Button, Space, Popconfirm, Select, Skeleton, Checkbox, Collapse, Row, Col, Typography, Popover, List, Tag, Modal, Input, notification, Flex } from 'antd';  
import { DeleteOutlined, FilterOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';  
  
const { Option } = Select;  
const { Text, Link } = Typography;  
  
const SoloEventsTable = ({ events, loading, openPopup, userRole, handleDeleteEvent, onSelectEvent, selectedEvents }) => {  
    const [filteredEvents, setFilteredEvents] = useState(events || []);  
    const [selectedEventName, setSelectedEventName] = useState('');  
    const [instrumentModalVisible, setInstrumentModalVisible] = useState(false);  
    const [currentEvent, setCurrentEvent] = useState(null);  
    const [instrumentName, setInstrumentName] = useState('');  
    const [otherInstrument, setOtherInstrument] = useState(false);  
  
    const eventOrder = ['Acting', 'Acting - Afrikaans', 'Dance', 'Instrumental', 'Modelling', 'Variety Acts', 'Vocal', 'Vocal - Afrikaans', 'Vocal - Self Accompaniment'];  
  
    const getUniqueEventNames = () => {  
        const uniqueNames = [...new Set((events || []).map(event => event.name))];  
        return uniqueNames.sort((a, b) => eventOrder.indexOf(a) - eventOrder.indexOf(b));  
    };  
  
    useEffect(() => {  
        const filtered = (events || []).filter(event =>  
            (selectedEventName ? event.name === selectedEventName : true)  
        );  
        setFilteredEvents(filtered);  
    }, [selectedEventName, events]);  
  
    const handleEventNameChange = (value) => {  
        setSelectedEventName(value);  
    };  
  
    const isSelected = (event) => selectedEvents.some(e => e._id === event._id);  
  
    const handleCheckboxChange = (event) => {  
        if (event.name === 'Instrumental') {  
            setCurrentEvent(event);  
            setInstrumentModalVisible(true);  
        } else {  
            onSelectEvent(event);  
        }  
    };  
  
    const handleInstrumentModalOk = () => {  
        if (instrumentName.trim() === '') {  
            notification.error({ message: 'Please enter the instrument name.' });  
            return;  
        }  
        onSelectEvent({ ...currentEvent, instrument: instrumentName });  
        setInstrumentModalVisible(false);  
        setInstrumentName('');  
        setOtherInstrument(false);  
    };  
  
    const handleInstrumentModalCancel = () => {  
        setInstrumentModalVisible(false);  
        setInstrumentName('');  
        setOtherInstrument(false);  
    };  
  
    const handleInstrumentSelect = (value) => {  
        if (value === 'OTHER') {  
            setOtherInstrument(true);  
            setInstrumentName('');  
        } else {  
            setOtherInstrument(false);  
            setInstrumentName(value);  
        }  
    };  
  
    const columns = [  
        {  
            title: 'Event Name',  
            dataIndex: 'name',  
            key: 'name',  
            sorter: (a, b) => eventOrder.indexOf(a.name) - eventOrder.indexOf(b.name),  
            sortDirections: ['ascend', 'descend'],  
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (  
                <div style={{ padding: 8 }}>  
                    <Select  
                        showSearch  
                        style={{ width: 188, marginBottom: 8, display: 'block' }}  
                        placeholder="Select an event"  
                        optionFilterProp="children"  
                        onChange={value => {  
                            setSelectedKeys(value ? [value] : []);  
                            handleEventNameChange(value);  
                            confirm();  
                        }}  
                        value={selectedEventName}  
                    >  
                        {getUniqueEventNames().map(name => (  
                            <Option key={name} value={name}>  
                                {name}  
                            </Option>  
                        ))}  
                    </Select>  
                    <Button  
                        onClick={() => {  
                            clearFilters();  
                            handleEventNameChange('');  
                            confirm();  
                        }}  
                        size="small"  
                        style={{ width: 90, marginTop: 8 }}  
                    >  
                        Clear  
                    </Button>  
                </div>  
            ),  
            filterIcon: (filtered) => <FilterOutlined style={{ color: filtered ? '#1271dd' : undefined }} />,  
            onFilter: (value, record) => record.name.includes(value),  
        }  
    ];  
  
    const expandedRowRender = (record) => {  
        const eventDetails = filteredEvents.filter(event => event.name === record.name);  
        const innerColumns = [  
            {  
                title: 'Style',  
                dataIndex: 'style',  
                key: 'style'  
            },  
            {  
                title: 'Actions',  
                key: 'actions',  
                render: (text, record) => {  
                    return (  
                        <Space>  
                            {userRole !== 'admin' ? (  
                                isSelected(record) ? (  
                                    <Popconfirm  
                                        title="Are you sure you want to unapply for this event?"  
                                        onConfirm={() => onSelectEvent(record)}  
                                        okText="Yes"  
                                        cancelText="No"  
                                    >  
                                        <Checkbox  
                                            checked={true}  
                                        />  
                                    </Popconfirm>  
                                ) : (  
                                    <Checkbox  
                                        checked={false}  
                                        onChange={() => handleCheckboxChange(record)}  
                                    />  
                                )  
                            ) : (  
                                <Popconfirm  
                                    title="Are you sure you want to delete this event?"  
                                    onConfirm={() => handleDeleteEvent(record._id)}  
                                    okText="Yes"  
                                    cancelText="No"  
                                >  
                                    <Button danger style={{ marginLeft: 8 }}>  
                                        <DeleteOutlined /> Delete  
                                    </Button>  
                                </Popconfirm>  
                            )}  
                        </Space>  
                    );  
                }  
            }  
        ];  
        return (  
            <Table  
                columns={innerColumns}  
                dataSource={eventDetails}  
                pagination={false}  
                rowKey="_id"  
                scroll={{ x: true }}  
            />  
        );  
    };  
  
    const uniqueEvents = getUniqueEventNames().map(name => ({  
        key: name,  
        label: name,  
        children: (  
            <Row gutter={[16, 16]}>  
                {filteredEvents.filter(event => event.name === name).map(event => (  
                    <Col xs={24} sm={12} md={8} key={event._id}>  
                        {isSelected(event) ? (  
                            <Popconfirm  
                                title="Are you sure you want to unapply for this event?"  
                                onConfirm={() => onSelectEvent(event)}  
                                okText="Yes"  
                                cancelText="No"  
                            >  
                                <Checkbox  
                                    checked={true}  
                                >  
                                    {event.style}  
                                </Checkbox>  
                            </Popconfirm>  
                        ) : (  
                            <Checkbox  
                                checked={false}  
                                onChange={() => handleCheckboxChange(event)}  
                            >  
                                {event.style}  
                            </Checkbox>  
                        )}  
                    </Col>  
                ))}  
            </Row>  
        )  
    }));  
  
    return (  
        <>  
            {loading ? (  
                <Skeleton active />  
            ) : (  
                <Space direction='vertical' size="large" style={{ width: '100%' }}>  
                    <Collapse  
                        accordion  
                        items={uniqueEvents}  
                        style={{ backgroundColor: 'white' }}  
                        expandIcon={({ isActive }) => !isActive ? <PlusOutlined /> : <MinusOutlined />}  
                        defaultActiveKey={uniqueEvents[0]?.key}  
                    />  
                    <Flex justify='flex-end'>  
                        <Space>  
                            <Text>Total Events: <Text strong>{selectedEvents.length}</Text></Text>  
                            <Popover title="Selected Events" content={  
                                <List style={{ maxHeight: '200px', overflowY: 'auto' }}  
                                    dataSource={selectedEvents.sort((a, b) => {  
                                        if (a.name < b.name) return -1;  
                                        if (a.name > b.name) return 1;  
                                        if (a.style < b.style) return -1;  
                                        if (a.style > b.style) return 1;  
                                        return 0;  
                                    })}  
                                    renderItem={(item) => (  
                                        <List.Item>  
                                            <Tag>{item.name}</Tag>  
                                            {item.style}  
                                            {item.instrument && <Text>({item.instrument})</Text>}  
                                        </List.Item>  
                                    )}  
                                />  
                            }>  
                                <Link>View Selected Events</Link>  
                            </Popover>  
                        </Space>  
                    </Flex>  
                </Space>  
            )}  
  
            <Modal  
                title="Instrument Name"  
                visible={instrumentModalVisible}  
                onOk={handleInstrumentModalOk}  
                onCancel={handleInstrumentModalCancel}  
            >  
                <Select  
                    style={{ width: '100%', marginBottom: 8 }}  
                    placeholder="Select an instrument"  
                    onChange={handleInstrumentSelect}  
                    value={otherInstrument ? 'OTHER' : instrumentName}  
                >  
                    <Option value="Drums">Drums</Option>  
                    <Option value="Guitar">Guitar</Option>  
                    <Option value="Piano">Piano</Option>  
                    <Option value="OTHER">OTHER</Option>  
                </Select>  
                {otherInstrument && (  
                    <Input  
                        placeholder="Enter the instrument you play"  
                        value={instrumentName}  
                        onChange={(e) => setInstrumentName(e.target.value)}  
                    />  
                )}  
            </Modal>  
        </>  
    );  
};  
  
export default SoloEventsTable;  